import React from "react";
import popimg from "../../assets/images/car-tooltip.png";

const VinTooltipButton = () => {
  const handleMouseEnter = (e) => {
    const tooltip = document.createElement("div");
    const tooltipWidth = 500;
    const tooltipHeight = 250;
    let isPositionedAbove = false;

    const updatePosition = () => {
      const rect = e.target.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;
      isPositionedAbove = spaceBelow < tooltipHeight && spaceAbove > spaceBelow;

      tooltip.style.left = `${rect.left + rect.width / 2 - tooltipWidth / 2}px`;

      if (isPositionedAbove) {
        tooltip.style.top = `${rect.top - tooltipHeight - 10}px`;
        tooltip.style.bottom = "auto";
      } else {
        tooltip.style.top = `${rect.bottom + 10}px`;
        tooltip.style.bottom = "auto";
      }
      updateArrow();
    };

    const updateArrow = () => {
      const topArrow = tooltip.querySelector(".tooltip-arrow-top");
      const bottomArrow = tooltip.querySelector(".tooltip-arrow-bottom");

      if (topArrow && bottomArrow) {
        if (isPositionedAbove) {
          topArrow.style.display = "none";
          bottomArrow.style.display = "block";
        } else {
          topArrow.style.display = "block";
          bottomArrow.style.display = "none";
        }
      }
    };

    tooltip.className = "vin-tooltip";
    tooltip.setAttribute("role", "tooltip");
    tooltip.style.position = "fixed";
    tooltip.style.zIndex = "100";
    tooltip.style.width = `${tooltipWidth}px`;
    tooltip.style.pointerEvents = "none";
    tooltip.style.opacity = "0";
    tooltip.style.transition = "opacity 0.2s ease-in-out";
    updatePosition();
    window.addEventListener("resize", updatePosition);
    tooltip.style.backgroundColor = "#ebebeb";
    tooltip.style.border = "1px solid #0003";
    tooltip.style.borderRadius = "4px";
    tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
    tooltip.style.padding = "0";
    setTimeout(() => {
      tooltip.style.opacity = "1";
    }, 50);

    tooltip.innerHTML = `
      <div style="position: relative;">
        <div class="tooltip-arrow-top" style="position: absolute; top: -8px; left: 50%; transform: translateX(-50%); width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-bottom: 8px solid #0003;"></div>
        <div class="tooltip-arrow-top" style="position: absolute; top: -7px; left: 50%; transform: translateX(-50%); width: 0; height: 0; border-left: 7px solid transparent; border-right: 7px solid transparent; border-bottom: 7px solid #ebebeb;"></div>
        <div class="tooltip-arrow-bottom" style="position: absolute; bottom: -8px; left: 50%; transform: translateX(-50%); width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-top: 8px solid #0003; display: none;"></div>
        <div class="tooltip-arrow-bottom" style="position: absolute; bottom: -7px; left: 50%; transform: translateX(-50%); width: 0; height: 0; border-left: 7px solid transparent; border-right: 7px solid transparent; border-top: 7px solid #ebebeb; display: none;"></div>
        <div className="popover-body" style="padding: 12px; text-align: left; ">
          <div className="vinPopover">
            <div className="d-flex">
              <div style="float:left; display:inline-block; width:275px; font-size:12px; margin-right: 25px;">
                Each car and truck built after 1980 has been stamped by the manufacturer with
                a unique vehicle identification number or VIN. The VIN is unique to the
                vehicle the way your fingerprint is unique to you, and it's how we are able to
                deliver critical vehicle specific data in the AutoCheck® vehicle history
                report. Looking for the VIN? Here's where you'll find it:
                <ul>
                  <li>On the driver's side dashboard near the windshield</li>
                  <li>Inside the driver's side door near the latch</li>
                  <li>On the owner's insurance card</li>
                </ul>
              </div>
              <div className="">
                <img src="${popimg}" alt="VIN location diagram" style={{width:200}} />
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(tooltip);
  };

  const handleMouseLeave = () => {
    const tooltip = document.querySelector(".vin-tooltip");
    if (tooltip) tooltip.remove();
  };

  return (
    <span
      className="clickLink smallLink m-2"
      aria-label="Learn where to find the VIN"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      Where can I find the VIN? »
    </span>
  );
};

export default VinTooltipButton;
